import { SearchType } from '@tyro/api';
import { useTranslation } from '@tyro/i18n';
import { useCallback } from 'react';
import type { RecipientsForMailModal } from '../components/common/select-mail-recipient-type-modal';

export function useResolveRecipients() {
  const { t } = useTranslation(['mail']);

  const getRecipientName = useCallback(
    (name: string, type: SearchType) => {
      switch (type) {
        case SearchType.ContactsOfStudent:
        case SearchType.GeneralGroupContact:
        case SearchType.SubjectGroupContact:
        case SearchType.YearGroupContact:
          return t('mail:contactsOfStudent', { name });
        case SearchType.GeneralGroupStaff:
        case SearchType.SubjectGroupStaff:
        case SearchType.YearGroupStaff:
        case SearchType.YearGroupEnrollment:
          return t('mail:staffOfGroup', { name });
        case SearchType.GeneralGroupStudent:
        case SearchType.SubjectGroupStudent:
        case SearchType.YearGroupStudent:
          return t('mail:studentOfGroup', { name });
        case SearchType.TeachersOfStudent:
          return t('mail:teachersOfX', { name });
        case SearchType.ClassGroupYearHeads:
        case SearchType.SubjectGroupYearHeads:
          return t('mail:yearHeadsOfX', { name });
        case SearchType.ClassGroupTutors:
        case SearchType.SubjectGroupTutors:
          return t('mail:tutorsOfX', { name });
        default:
          return name;
      }
    },
    [t],
  );

  const resolveMailRecipients = useCallback(
    (parties: RecipientsForMailModal, types: SearchType[]) =>
      parties.flatMap((party) =>
        types.map(
          (type) =>
            ({
              __typename: 'Search',
              partyId: party.id,
              type: type,
              text: getRecipientName(party.name, type),
              avatarUrl: party.avatarUrl,
            }) as const,
        ),
      ),
    [getRecipientName],
  );

  return { resolveMailRecipients };
}
